/**
 * The marketplace an aggregated listing or offer came from. Absent on our own
 * (Rarible) listings and offers.
 */
export const ListingSource = {
  MAGIC_EDEN: "MAGIC_EDEN",
  OPEN_SEA: "OPEN_SEA",
  TENSOR: "TENSOR",
  ORBIS: "ORBIS",
} as const

export type ListingSource = (typeof ListingSource)[keyof typeof ListingSource]

/** Display name of each source. Brand names, so never translated. */
export const LISTING_SOURCE_NAME: Record<ListingSource, string> = {
  [ListingSource.MAGIC_EDEN]: "Magic Eden",
  [ListingSource.OPEN_SEA]: "OpenSea",
  [ListingSource.TENSOR]: "Tensor",
  [ListingSource.ORBIS]: "Orbis",
}

/**
 * What the buyer pays on top of the listed price when buying a Solana listing
 * through its own marketplace, in basis points. Royalties come on top where a
 * collection enforces them.
 *
 * Orbis quotes listings all-in: its seller pays the marketplace fee, so the
 * buyer pays exactly the listed price.
 */
export const SOLANA_EXTERNAL_BUYER_FEE_BPS: Partial<
  Record<ListingSource, number>
> = {
  [ListingSource.MAGIC_EDEN]: 200,
  [ListingSource.TENSOR]: 200,
  [ListingSource.ORBIS]: 0,
}

/**
 * A listing that lives on another marketplace. It can be bought through that
 * marketplace, but not cancelled, edited or bulk-bought from here.
 */
export function isExternalListing(
  listingSource: ListingSource | undefined,
): listingSource is ListingSource {
  return listingSource !== undefined
}

export function isMagicEdenListing(
  listingSource: ListingSource | undefined,
): boolean {
  return listingSource === ListingSource.MAGIC_EDEN
}

export function isOpenSeaListing(
  listingSource: ListingSource | undefined,
): boolean {
  return listingSource === ListingSource.OPEN_SEA
}

export function isTensorListing(
  listingSource: ListingSource | undefined,
): boolean {
  return listingSource === ListingSource.TENSOR
}

export function isOrbisListing(
  listingSource: ListingSource | undefined,
): boolean {
  return listingSource === ListingSource.ORBIS
}
